import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import IdeaCard from '../components/IdeaCard';
import SubmitIdea from '../components/SubmitIdea';
import api from '../api';

export default function Home() {
  const { user } = useAuth();
  const [ideas, setIdeas] = useState([]);
  const [votedIdeas, setVotedIdeas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchIdeas = async () => {
    try {
      const res = await api.get('/ideas');
      setIdeas(res.data);
    } catch (err) {
      setError('Failed to load ideas');
    } finally {
      setLoading(false);
    }
  };

  const fetchVotedIdeas = async () => {
    if (!user) return setVotedIdeas([]);
    try {
      const res = await api.get('/votes/my');
      setVotedIdeas(res.data);
    } catch (err) {
      console.error('Failed to load votes');
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);

  useEffect(() => {
    fetchVotedIdeas();
  }, [user]);

  const handleRefresh = () => {
    fetchIdeas();
    fetchVotedIdeas();
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>

        {/* Hero */}
        <div style={styles.hero}>
          <h1 style={styles.heroTitle}>What should we teach next?</h1>
          <p style={styles.heroSub}>
            Vote for AlcatelUnleashed training topics you want most.
            Each week you get 2 new post credits and 2 new vote credits.
          </p>
        </div>

        {/* Stats bar */}
        <div style={styles.statsBar}>
          <span style={styles.stat}>📋 {ideas.length} ideas submitted</span>
          {user && (
            <>
              <span style={styles.divider}>|</span>
              <span style={styles.stat}>✏️ {user.post_credits} post credits left</span>
              <span style={styles.divider}>|</span>
              <span style={styles.stat}>👍 {user.vote_credits} vote credits left</span>
            </>
          )}
        </div>

        {/* Submit idea */}
        <SubmitIdea onSubmit={handleRefresh} />

        {/* Ideas list */}
        {loading ? (
          <div style={styles.loading}>Loading ideas...</div>
        ) : error ? (
          <div style={styles.error}>{error}</div>
        ) : ideas.length === 0 ? (
          <div style={styles.empty}>
            <p>No ideas yet — be the first to submit one! 👆</p>
          </div>
        ) : (
          <div>
            {ideas.map(idea => (
              <IdeaCard
                key={idea.id}
                idea={idea}
                votedIdeas={votedIdeas}
                onVote={handleRefresh}
                onDelete={handleRefresh}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f9fafb',
  },
  container: {
    maxWidth: '720px',
    margin: '0 auto',
    padding: '40px 24px',
  },
  hero: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  heroTitle: {
    fontSize: '32px',
    fontWeight: '800',
    color: '#111827',
    margin: '0 0 12px 0',
  },
  heroSub: {
    fontSize: '16px',
    color: '#6b7280',
    lineHeight: '1.6',
    margin: 0,
  },
  statsBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '24px',
    padding: '12px',
    background: '#ffffff',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
  },
  stat: {
    fontSize: '13px',
    color: '#6b7280',
  },
  divider: {
    color: '#d1d5db',
  },
  loading: {
    textAlign: 'center',
    color: '#9ca3af',
    padding: '40px',
  },
  error: {
    textAlign: 'center',
    color: '#ef4444',
    padding: '40px',
  },
  empty: {
    textAlign: 'center',
    color: '#9ca3af',
    padding: '40px',
    background: '#ffffff',
    borderRadius: '10px',
    border: '1px solid #e5e7eb',
  },
};